export default __webpack_public_path__ + "static/media/logo_long_light.0735bbc3.svg";